module.exports = __webpack_public_path__ + "media/images/pages/telegram_white-7ff81dd570faa277b428199cccd16e1c.png";